/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useEffect, useState } from 'react'
import { Box, Link, Typography } from '@material-ui/core'
import { useHistory, useParams } from 'react-router-dom'
import { reverse } from 'named-urls'
import PropTypes from 'prop-types'
import { isNil } from 'lodash'

import useSnackbar from 'hooks/useSnackbar'

import useStyles from './styles'
import * as service from 'service'
import { routes } from 'Routes'
import constants from 'constants/index'

const ResendEmail = ({ accessToken }) => {
  const { PLATFORM_SLUG_ID } = constants.settings

  const [enableResendButton, setEnableResendButton] = useState(false)
  const [counter, setCounter] = useState(30)
  const [loading, setLoading] = useState(false)

  const classes = useStyles()
  const snackbar = useSnackbar()
  const history = useHistory()
  const { slug } = useParams()

  const defineErrorMessage = (error) => {
    const errorMessage = error?.response.data?.error?.message

    return errorMessage || 'Ocorreu algum erro! Tente novamente!'
  }

  const hasSlug =
    !isNil(slug) &&
    !constants.settings.DEFAULT_SLUGS_PATHS.includes(slug?.toLowerCase())

  const resendEmail = async () => {
    setLoading(true)
    try {
      await service.dponet.twoFactorAuthentication.resendCode({
        accessToken,
        ...(hasSlug && { publicPath: slug }),
      })
      setEnableResendButton(false)

      snackbar.open({
        message: 'O código foi reenviado, fique atento(a) ao seu e-mail.',
        variant: 'success',
      })
    } catch (error) {
      if (error.response.status === 403)
        return history.push(
          reverse(routes.root, {
            slug: slug || PLATFORM_SLUG_ID,
          }),
        )

      snackbar.open({
        message: defineErrorMessage(error),
        variant: 'error',
      })
    }
    setLoading(false)
  }

  useEffect(() => {
    // Quantidade de segundos para aparecer o botão
    if (!enableResendButton) setEnableResendButton(counter === 0)

    const timer =
      !enableResendButton && setInterval(() => setCounter(counter - 1), 1000)

    return () => clearInterval(timer)
  }, [counter])

  useEffect(() => {
    if (!enableResendButton && counter !== 1) setCounter(30)
  }, [enableResendButton])

  return (
    <Box>
      <Typography variant="subtitle1" paragraph>
        Não recebeu seu código?&nbsp;
        {loading ? (
          <strong>Carregando...</strong>
        ) : enableResendButton ? (
          <Link
            className={classes.link}
            onClick={resendEmail}
            aria-disabled={loading}
          >
            Reenvie
          </Link>
        ) : (
          <strong>Reenvie em {counter} segundos</strong>
        )}
      </Typography>
    </Box>
  )
}

ResendEmail.propTypes = {
  accessToken: PropTypes.string.isRequired,
}

export default memo(ResendEmail)
